var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.28245 0.858508V0.477834C8.28245 0.213432 8.06902 0 7.80462 0C7.54022 0 7.32679 0.213432 7.32679 0.477834V0.848951H3.82267V0.477834C3.82267 0.213432 3.60924 0 3.34484 0C3.08044 0 2.867 0.213432 2.867 0.477834V0.858508C1.27104 0.947704 0 2.2713 0 3.88797V8.96098C0 10.6366 1.36342 12 3.03902 12H8.11203C9.78604 12 11.1495 10.6366 11.1495 8.96098V3.88797C11.1495 2.2713 9.87842 0.949296 8.28245 0.858508ZM10.1938 8.96098C10.1938 10.1094 9.25883 11.0443 8.11043 11.0443H3.03902C1.89063 11.0443 0.955668 10.1094 0.955668 8.96098V3.88797C0.955668 2.79692 1.79825 1.90178 2.867 1.81418V2.11043C2.867 2.37483 3.08044 2.58827 3.34484 2.58827C3.60924 2.58827 3.82267 2.37483 3.82267 2.11043V1.80621H7.32679V2.11043C7.32679 2.37483 7.54022 2.58827 7.80462 2.58827C8.06902 2.58827 8.28245 2.37483 8.28245 2.11043V1.81418C9.35121 1.90178 10.1938 2.79851 10.1938 3.88797V8.96098Z",
    fill: "#616161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03755 5.05188L5.12463 6.96799L4.11003 5.95339C3.92367 5.76703 3.62104 5.76703 3.43469 5.95339C3.24833 6.13974 3.24833 6.44237 3.43469 6.62873L4.44929 7.64333C4.62927 7.82331 4.86978 7.92366 5.12463 7.92366C5.37947 7.92366 5.61998 7.82491 5.79997 7.64333L7.71608 5.72721C7.90243 5.54086 7.90243 5.23823 7.71608 5.05188C7.52654 4.86552 7.22391 4.86552 7.03755 5.05188Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndDate);
export default __webpack_public_path__ + "static/media/end-date.22e5f0721455b2c7b9a8c914712f38e6.svg";
export { ForwardRef as ReactComponent };